// Mock data (German primary) for Airport Taxi Zürich.
// NOTE: content is static/MOCK on the frontend. Prices are example values.
// BRAND is centralized in ./config/brand — edit that file to rebrand.

export { BRAND } from "./config/brand";

export const HERO = {
  image:
    "https://customer-assets.emergentagent.com/job_taxi-zurich-flight/artifacts/s9hob1ws_43DCFE51-A156-4509-ABED-01DA29765880.png",
};

export const SERVICES = {
  kicker: "Bestens ankommen",
  title: "Mühelose Fahrten, ganz nach Ihren Wünschen.",
  subtitle: "Wählen Sie Ihren Abholort in der gesamten Region Zürich. Wir sind pünktlich da.",
  items: [
    {
      title: "Flughafentransfer",
      desc: "Flug verspätet? Ihr Chauffeur verfolgt die Ankunft und passt sich an. Kostenlose Wartezeit inklusive.",
      img: "https://static.prod-images.emergentagent.com/jobs/2c3518a3-4c9c-454e-8698-21a3b571ac3c/images/a84b00260713764b286121d850882114d7e1b0cb03b240f1e159f044798a01da.jpeg",
      link: "/flughafentransfer",
    },
    {
      title: "Stadt zu Stadt",
      desc: "Machen Sie aus langen Strecken wertvolle Zeit. Kommen Sie erholt an, nicht gestresst.",
      img: "https://static.prod-images.emergentagent.com/jobs/2c3518a3-4c9c-454e-8698-21a3b571ac3c/images/31d5a5cdf828bbcead3e14793e2346a4dc6b59bc84ec61948f7b594f7810fb98.jpeg",
      link: "/stadttransfer-zurich",
    },
    {
      title: "Stunden- & Tagesmiete",
      desc: "Reservieren Sie einen Chauffeur, so lange Sie ihn brauchen — bereit für jeden Stopp.",
      img: "https://static.prod-images.emergentagent.com/jobs/2c3518a3-4c9c-454e-8698-21a3b571ac3c/images/2ade454ff585ed1629a9356868d2a10318552ff2619dd5636e9f406db6832ddf.jpeg",
      link: "/stundenservice-zurich",
    },
    {
      title: "Geschäftsreisen",
      desc: "Eine Plattform, um jede Firmenfahrt zu buchen, zu verfolgen und abzurechnen.",
      img: "https://static.prod-images.emergentagent.com/jobs/2c3518a3-4c9c-454e-8698-21a3b571ac3c/images/eb504e724a15ef645236a41a416b7aa5e87e5e445daef37de85ff18da21ae92e.jpeg",
      link: "/business-transfer-zurich",
    },
  ],
};

export const EXPERIENCE = {
  title: "Einsteigen. Durchatmen.",
  subtitle:
    "Durchdachte Details und diskreter Service verwandeln jede Fahrt in Ihren persönlichen Rückzugsort.",
  items: [
    {
      icon: "door",
      title: "Ein Empfang wie kein anderer",
      desc: "Die Tür wird für Sie geöffnet. Ihr Gepäck wird verstaut. Um alles ist gesorgt.",
      img: "https://images.pexels.com/photos/8425027/pexels-photo-8425027.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
    {
      icon: "music",
      title: "Sie geben den Ton an",
      desc: "Lehnen Sie sich zurück. Musik und Temperatur ganz nach Ihren Wünschen.",
      img: "https://customer-assets.emergentagent.com/job_taxi-zurich-flight/artifacts/ugrfnbaa_IMG_2660.jpeg",
    },
    {
      icon: "battery",
      title: "Kräfte tanken",
      desc: "Bleiben Sie unterwegs verbunden — mit Ladegeräten für jedes Gerät.",
      img: "https://images.pexels.com/photos/4406040/pexels-photo-4406040.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    },
  ],
};

export const FLEET = {
  title: "Unsere Flotte",
  subtitle:
    "Makellose, lizenzierte Fahrzeuge für jede Fahrt — von der Geschäftsreise bis zur Familienankunft.",
  items: [
    { name: "Economy Klasse", model: "Škoda Octavia o. ä.", seats: "3 Sitze", link: "/booking?veh=economy", img: "https://customer-assets.emergentagent.com/job_zurich-airport-cab/artifacts/x5ooji4t_IMG-20260704-WA0000.jpg" },
    { name: "Standard XXL Van", model: "Mercedes V-Klasse XXL", seats: "7 Sitze", link: "/gruppentransfer-zurich", img: "https://static.prod-images.emergentagent.com/jobs/d11c1f14-a29e-48e3-b4e1-8d772573ce5f/images/0bf1e9dc45a1894080e939c366608a58879df43c993c7fc5440be65fc5e24a63.png" },
    { name: "First Class", model: "Mercedes-Maybach / S-Klasse", seats: "3 Sitze", link: "/business-transfer-zurich", img: "https://static.prod-images.emergentagent.com/jobs/d11c1f14-a29e-48e3-b4e1-8d772573ce5f/images/4a6f1bb5b20a7333c87fce7bbb7941d16e11e75aab59f90160f036b9295b132f.png" },
    { name: "Business Class", model: "Mercedes E-Klasse / Audi A6 / BMW 5er", seats: "3 Sitze", link: "/booking?veh=business", img: "https://static.prod-images.emergentagent.com/jobs/d11c1f14-a29e-48e3-b4e1-8d772573ce5f/images/70c63dbf3a7a830cd4e30f3f5263d0e0192940397ace6a8a655c7bd970e8eedb.png" },
    { name: "Sprinter", model: "Mercedes Sprinter", seats: "14 Sitze", link: "/gruppentransfer-zurich", img: "https://static.prod-images.emergentagent.com/jobs/d11c1f14-a29e-48e3-b4e1-8d772573ce5f/images/105ea2e1c70d04052a481ccadc7a6b88c282dc11a2160bb6240fd615917c0ae0.png" },
  ],
};

export const EXCELLENCE = {
  kicker: "Erwarten Sie Spitzenqualität",
  title: "Steigen Sie erholt aus – bereit für alles, was kommt.",
  items: [
    { icon: "check", title: "Fixpreise", desc: "Transparente Preise, keine Überraschungen" },
    { icon: "star", title: "Hochwertige Fahrzeuge", desc: "Nur die besten, neuen Modelle" },
    { icon: "shield", title: "Sichere Fahrten", desc: "Geschulte Profis, zuverlässige Abholung" },
    { icon: "clock", title: "Flugverfolgung", desc: "Wir passen uns Ihrer Ankunft an, 24/7" },
  ],
};

export const JOURNAL = {
  kicker: "Reiseratgeber",
  title: "Klüger durch die Schweiz reisen.",
  items: [
    { tag: "Alpen-Transfer", title: "Vom Flughafen Zürich nach Davos – Ihr Transfer in die Alpen", img: "https://images.unsplash.com/photo-1620983379290-71e02d8ca563?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600", link: "/ratgeber/flughafen-zuerich-nach-davos" },
    { tag: "Preisguide", title: "Was kostet ein Taxi vom Flughafen Zürich?", img: "https://images.pexels.com/photos/38595343/pexels-photo-38595343.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", link: "/ratgeber/taxi-preis-flughafen-zuerich" },
    { tag: "Familie", title: "Flughafentransfer mit Kindern – sicher und entspannt", img: "https://images.pexels.com/photos/7708639/pexels-photo-7708639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", link: "/ratgeber/flughafentransfer-mit-kindern" },
  ],
};

export const REVIEWS = {
  kicker: "Von Reisenden bewertet",
  title: "Beliebt bei Gästen in der ganzen Schweiz.",
  promise:
    "Tausende Transfers, ein Versprechen: pünktlich, komfortabel und transparent — jedes Mal.",
  google: { score: "5.0", label: "Google Bewertungen", url: "https://www.google.com/search?q=Airport+Taxi+Z%C3%BCrich+airporttaxi24.ch" },
  trustpilot: { score: "4.1", label: "14 Bewertungen auf Trustpilot", url: "https://ch.trustpilot.com/review/airporttaxi24.ch" },
};

export const CONTACT = {
  kicker: "Kontakt aufnehmen",
  title: "Wir sind rund um die Uhr für Sie da.",
  subtitle:
    "Fragen, Gruppenbuchungen oder Sonderwünsche? Rufen Sie an, schreiben Sie per WhatsApp oder E-Mail.",
};
